import { useCallback, useRef, useState } from 'react';

import service, { didAbort } from '@/services/index';
import { useToast } from '@/stores/pure/ToastStore';

const useFetchAccountSentimentList = () => {
  const [accountSentimentList, setAccountSentimentList] = useState<
    CustomerSentimentBaseListItemT[]
  >([]);
  const abortControllerRef = useRef<AbortController>();
  const addToast = useToast();

  const fetchAccountSentimentList = useCallback(
    async (params: FetchCustomerSentimentListParams) => {
      try {
        // Abort the previous request if there was one
        abortControllerRef.current?.abort();

        // Create a new AbortController
        abortControllerRef.current = new AbortController();

        const newAccountSentimentList =
          await service.customer.fetchAccountSentimentList(params, {
            signal: abortControllerRef.current.signal,
          });

        setAccountSentimentList(newAccountSentimentList);
        return newAccountSentimentList;
      } catch (error) {
        console.error(error);
        if (!didAbort(error)) {
          addToast('Failed to get account list', 'fail');
        }
        return [];
      }
    },
    [addToast],
  );

  return {
    accountSentimentList,
    fetchAccountSentimentList,
  };
};

export default useFetchAccountSentimentList;
